export async function clearAppCache() {
  if (typeof window === "undefined") return { cleared: 0 };

  let cleared = 0;

  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(
      keys
        .filter((key) => key.startsWith("bainv-"))
        .map(async (key) => {
          const deleted = await caches.delete(key);
          if (deleted) cleared += 1;
        })
    );
  }

  if ("serviceWorker" in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      await registration.update();
    }
  }

  return { cleared };
}
